/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from "react";
import ShowPassword from "../Icon/eye.svg";
import HidePassword from "../Icon/eye-slash.svg";
import EmailIcon from "../Icon/envelope.svg";
import UblockIcon from "../Icon/unlock.svg";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import CloseIcon from "../Icon/times.svg";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { MyContext } from "../Context/MyProvider";
import { TodoContext } from "../Context";
import { showTost } from "../showTost";
import { uid } from "uid";
import { fetchProfileCompletion } from "../utils/profileCompletion";
import { getOtpDeviceId } from "../utils/otpDeviceId";
import bg2 from "../images/backgrounds/bg-2.png";
import { FiMail, FiLock } from "react-icons/fi";
import { FaHeart, FaShieldAlt } from "react-icons/fa";
import { BiRightArrowAlt } from "react-icons/bi";

const Login = () => {

  const Data = useContext(TodoContext);
  const { basUrl, setToastShow } = useContext(MyContext);

  const [Email, setemail] = useState("");
  const [Password, setpassword] = useState("");
  const [Confirm, setconfirm] = useState();
  const [Password2, setpassword2] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const [value, setValue] = useState();
  const [otpValue, setOtpValue] = useState([]);
  const [otpSessionId, setOtpSessionId] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [otpShow, setOtpShow] = useState(true);
  const [otpPhone, setOtpPhone] = useState({ mobile: "", ccode: "" });
  const [smsType, setSmsType] = useState("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showResetConfirmPassword, setShowResetConfirmPassword] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);

  const navigate = useNavigate();

  const Show = useRef();
  const Hide = useRef();
  const inputFocus = useRef();
  const Inputref = useRef(Array.from({ length: 6 }, () => null));

  function myFunction() {
    var x = document.getElementById("input");
    if (x.type === "password") {
      x.type = "text";
      Show.current.style.display = "block";
      Hide.current.style.display = "none";
    } else {
      x.type = "password";
      Hide.current.style.display = "block";
      Show.current.style.display = "none";
    }
  }

  const SigninHandler = () => {
    const Validation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (Email && Password) {
      axios
        .post(`${basUrl}user_login`, {
          mobile: Email,
          ccode: "+91",
          password: Password,
        })
        .then(async (res) => {
          if (res.data.Result === "true") {
            setToastShow(true);
            showTost({ title: res.data.ResponseMsg });
            Data.setDemo(Data.demo + "123");
            const token = res.data.token || uid(32);
            localStorage.setItem("token", token);
            localStorage.setItem("UserId", res.data.UserLogin.id);
            localStorage.setItem("Register_User", JSON.stringify({ ...res.data.UserLogin, token }));
            await fetchProfileCompletion(basUrl, res.data.UserLogin.id);
            setTimeout(() => {
              navigate("/");
            }, 500);
          } else {
            showTost({ title: res.data.ResponseMsg });
          }
        })
        .catch((error) => {
          console.error("Login request failed:", error);
          showTost({
            title: error?.response?.data?.ResponseMsg || error?.message || "Unable to connect to backend.",
          });
        });
    } else if (!Validation.test(Email)) {
      showTost({ title: "Please Enter Valid Email" });
    } else if (!Email) {
      showTost({ title: "Please Enter Email" });
    } else if (!Password) {
      showTost({ title: "Please Enter Password" });
    }
  };

  const toggleBottomSheet = () => {
    setIsVisible(!isVisible);
    setOtpShow(false);
    setValue("");
    setOtpValue([]);
    setTimeLeft(0);
    setPasswordShow(false);
    setpassword2("");
    setconfirm("");
    setShowResetPassword(false);
    setShowResetConfirmPassword(false);
  };

  const startOtpTimer = () => {
    setTimeLeft(30);
  };

  const sendForgotOtp = async (provider, mobile, ccode) => {
    setIsSendingOtp(true);
    try {
      const endpoint = provider === "Twilio" ? "twilio_otp" : "msg_otp";
      const res = await axios.post(`${basUrl}${endpoint}`, { mobile, ccode, device_id: getOtpDeviceId() });
      if (res.data.Result !== "true") {
        throw new Error(res.data.ResponseMsg || "Unable to send OTP");
      }
      showTost({ title: res.data.ResponseMsg || "Otp sent successfully!!" });
      setOtpSessionId(res.data.otp_session_id || "");
      
      const autoOtp = String(
        res.data.otp ||
        res.data.otp_code ||
        res.data.otp_autofill ||
        res.data.code ||
        res.data.Otp ||
        res.data.OTP ||
        res.data.user_otp ||
        res.data.otp_value ||
        ""
      ).replace(/\D/g, "");

      if (autoOtp && autoOtp.length > 0) {
        const digits = autoOtp.slice(0, 6).split("");
        setOtpValue(digits);
        setTimeout(() => {
          Inputref.current[Math.min(digits.length, 6) - 1]?.focus();
        }, 100);
      } else {
        setOtpValue([]);
      }

      startOtpTimer();
    } catch (error) {
      showTost({ title: "Unable to send OTP. Please try again." });
    } finally {
      setIsSendingOtp(false);
    }
  };

  const PhoneHandler = () => {
    if (value) {
      if (value.length === 13) {
        const Num = value.slice(3);
        const Code = value.slice(0, 3);
        setOtpPhone({ mobile: Num, ccode: Code });

        axios.post(`${basUrl}mobile_check`,
          {
            mobile: Num,
            ccode: Code
          }
        )
          .then((res) => {
            if (res.data.Result === "true") {
              showTost({ title: res.data.ResponseMsg });
            } else {
              axios.post(`${basUrl}sms_type`)
                .then((res) => {
                  if (res.data.Result === "true") {
                    if (res.data.otp_auth === "Yes") {
                      const provider = res.data.SMS_TYPE === "Twilio" ? "Twilio" : "Msg91";
                      setSmsType(provider);
                      setOtpShow(true);
                      sendForgotOtp(provider, Num, Code);
                    } else {
                      setPasswordShow(true);
                    }
                  }
                });
            }
          });
      } else {
        showTost({ title: "Please Enter Valid MobileNumber" });
      }
    } else {
      showTost({ title: "Please Enter MobileNumber" });
    }
  };

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setTimeout(() => {
      setTimeLeft(prevTimeLeft => {
        return prevTimeLeft <= 1 ? 0 : prevTimeLeft - 1;
      });
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  const ResendOtpHandler = () => {
    if (timeLeft > 0 || isSendingOtp) return;
    sendForgotOtp(smsType, otpPhone.mobile, otpPhone.ccode);
  };

  const OtpCheckHandler = async () => {
    if (isVerifyingOtp) return;

    const enteredOtp = otpValue.join('');
    if (enteredOtp.length < 6) {
      showTost({ title: "Please enter valid Otp" });
      return;
    }

    setIsVerifyingOtp(true);
    try {
      const res = await axios.post(`${basUrl}verify_otp`, {
        otp_session_id: otpSessionId,
        otp: enteredOtp,
        mobile: otpPhone.mobile,
        ccode: otpPhone.ccode,
        device_id: getOtpDeviceId(),
      });

      if (res.data.Result === "true") {
        showTost({ title: "Otp Match Successfully" });
        setOtpShow(false);
        setPasswordShow(true);
      } else {
        showTost({ title: res.data.ResponseMsg || "Invalid Otp" });
      }
    } catch (error) {
      showTost({ title: "Unable to verify OTP. Please try again." });
    }
    setIsVerifyingOtp(false);
  };

  const isResetPasswordValid = Password2 && Password2.length >= 6;
  const isResetConfirmValid = Confirm && Confirm === Password2;

  const SubmitHandler = async () => {
    if (isChangingPassword) return;

    if (!Password2) {
      showTost({ title: "Please Enter Password" });
      return;
    }

    if (!isResetPasswordValid) {
      showTost({ title: "Password must be at least 6 characters" });
      return;
    }

    if (!Confirm) {
      showTost({ title: "Please Enter Confirm Password" });
      return;
    }

    if (!isResetConfirmValid) {
      showTost({ title: "Password does not match" });
      return;
    }

    setIsChangingPassword(true);
    try {
      const res = await axios.post(`${basUrl}forget_password`,
        {
          mobile: value.slice(3),
          password: Confirm,
          ccode: value.slice(0, 3)
        }
      );

      if (res.data.Result === "true") {
        showTost({ title: res.data.ResponseMsg });
        toggleBottomSheet();
        setValue('');
        setOtpValue([]);
        setpassword2("");
        setconfirm("");
        setPasswordShow(false);
      } else {
        showTost({ title: res.data.ResponseMsg || "Unable to change password" });
      }
    } catch (error) {
      showTost({ title: "Unable to change password. Please try again." });
    } finally {
      setIsChangingPassword(false);
    }
  };

  const HandleChange = (index, value) => {
    const Otp = [...otpValue];
    Otp[index] = value;
    setOtpValue(Otp);

    if (value && !isNaN(value) && index < Inputref.current.length - 1) {
      Inputref.current[index + 1].focus();
    }
  };

  const InputHandler = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !e.target.value) {
      Inputref.current[index - 1].focus();
    }
  };

  return (
    <div className="min-h-screen w-full relative flex items-center justify-center p-4 sm:p-6 lg:p-8 font-sans overflow-x-hidden" style={{ backgroundImage: `url(${bg2})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover" }}>
      {/* Dark Ambient Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-tr from-purple-950/70 via-black/50 to-indigo-950/70 backdrop-blur-[2px] z-0" />

      <div className="relative z-10 w-full max-w-[460px] mx-auto">
        {/* Glassmorphic Login Card */}
        <div className="bg-white/95 backdrop-blur-2xl rounded-3xl p-6 sm:p-8 shadow-2xl border border-white/80 transition-all duration-300">
          
          {/* Dating Brand Header */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-purple-100/90 text-purple-700 text-xs font-bold mb-3 shadow-xs border border-purple-200/50">
              <FaHeart className="text-purple-600 animate-pulse text-sm" />
              <span>Welcome Back to GoMeet</span>
            </div>
            <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight m-0">
              Sign In
            </h1>
            <p className="text-xs sm:text-sm text-gray-500 font-medium mt-1.5 m-0">
              Find real connections & meet amazing people near you.
            </p>
          </div>

          {/* Form */}
          <form onSubmit={(e) => { e.preventDefault(); SigninHandler(); }} className="space-y-4">
            
            {/* Email / Mobile Field */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                Email or Mobile Number
              </label>
              <div className="relative flex items-center border border-gray-300 rounded-2xl bg-gray-50/70 focus-within:bg-white focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all h-12 px-3.5 gap-3">
                <FiMail className="text-gray-400 text-lg shrink-0" />
                <input
                  className="w-full bg-transparent text-sm text-gray-900 font-medium outline-none placeholder:text-gray-400"
                  type="text"
                  placeholder="Enter email or mobile number"
                  onChange={(e) => setemail(e.target.value)}
                  value={Email}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      SigninHandler();
                    }
                  }}
                />
              </div>
            </div>

            {/* Password Field */}
            <div>
              <label className="block text-xs font-semibold text-gray-700 mb-1.5">
                Password
              </label>
              <div className="relative flex items-center border border-gray-300 rounded-2xl bg-gray-50/70 focus-within:bg-white focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all h-12 px-3.5 gap-3">
                <FiLock className="text-gray-400 text-lg shrink-0" />
                <input
                  id="input"
                  type={showLoginPassword ? "text" : "password"}
                  className="w-full bg-transparent text-sm text-gray-900 font-medium outline-none pr-8 placeholder:text-gray-400"
                  placeholder="Enter your password"
                  onChange={(e) => setpassword(e.target.value)}
                  value={Password}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      SigninHandler();
                    }
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowLoginPassword(!showLoginPassword)}
                  className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-purple-600 p-1 cursor-pointer transition-colors z-10"
                  title={showLoginPassword ? "Hide password" : "Show password"}
                >
                  <img
                    src={showLoginPassword ? ShowPassword : HidePassword}
                    alt="Toggle password"
                    className="w-5 h-5 object-contain"
                  />
                </button>
              </div>
            </div>

            {/* Remember Me & Forgot Password Row */}
            <div className="flex items-center justify-between pt-1 text-xs sm:text-sm">
              <label className="flex items-center gap-2 text-gray-600 font-medium cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="rounded accent-purple-600 w-4 h-4 cursor-pointer"
                />
                <span>Remember me</span>
              </label>
              <button
                type="button"
                onClick={toggleBottomSheet}
                className="font-bold text-purple-600 hover:text-purple-700 hover:underline transition-colors cursor-pointer"
              >
                Forgot password?
              </button>
            </div>

            {/* Sign In Button */}
            <button
              type="submit"
              className="w-full mt-4 py-3.5 px-6 rounded-2xl bg-gradient-to-r from-purple-600 via-purple-700 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-bold text-sm sm:text-base shadow-lg shadow-purple-500/25 transition-all transform active:scale-[0.98] cursor-pointer flex items-center justify-center gap-2 tracking-wide"
            >
              <span>Sign In</span>
              <BiRightArrowAlt className="text-xl" />
            </button>
          </form>

          {/* Footer Link */}
          <div className="mt-6 pt-5 border-t border-gray-100 text-center">
            <p className="text-xs sm:text-sm font-medium text-gray-600 m-0">
              Don't have an account?{" "}
              <Link
                to="/register"
                className="font-bold text-purple-600 hover:text-purple-700 hover:underline transition-all ml-1 cursor-pointer"
              >
                Sign Up for Free
              </Link>
            </p>
          </div>
        </div>

        {/* Dating Safety Badges */}
        <div className="mt-4 flex items-center justify-center gap-4 text-white/80 text-xs font-semibold">
          <span className="flex items-center gap-1.5 bg-black/30 backdrop-blur-md px-3 py-1.5 rounded-full border border-white/10">
            <FaShieldAlt className="text-purple-400 text-xs" />
            100% Safe & Private
          </span>
          <span className="flex items-center gap-1.5 bg-black/30 backdrop-blur-md px-3 py-1.5 rounded-full border border-white/10">
            <FaHeart className="text-pink-400 text-xs" />
            Verified Profiles
          </span>
        </div>
      </div>

      {isVisible && (
        <div
          onClick={toggleBottomSheet}
          className="fixed inset-0 bg-black/60 backdrop-blur-xs flex items-center justify-center p-4 z-[99999]"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white w-full max-w-[440px] rounded-3xl p-6 shadow-2xl border border-gray-100 overflow-hidden"
          >
            <div className="flex items-center justify-between pb-3 border-b border-gray-100 mb-4">
              <div>
                <h3 className="text-lg font-bold text-gray-900 m-0">Reset Password</h3>
                <p className="text-xs text-gray-500 font-medium m-0 mt-0.5">
                  {otpShow ? "Enter OTP sent to your phone" : passwordShow ? "Create a new password" : "Enter mobile number to receive OTP"}
                </p>
              </div>
              <button
                type="button"
                onClick={toggleBottomSheet}
                className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 transition-colors cursor-pointer"
              >
                <img src={CloseIcon} alt="Close" className="w-4 h-4" />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">
                  Mobile Number
                </label>
                <div className="border border-gray-300 rounded-2xl bg-gray-50/70 focus-within:bg-white focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all p-1">
                  <PhoneInput
                    ref={inputFocus}
                    className="text-black w-full px-3 py-2 font-medium text-sm outline-none"
                    international
                    defaultCountry="IN"
                    value={value}
                    onChange={setValue}
                    inputStyle={{ outline: "none", border: "none", background: "transparent" }}
                  />
                </div>
              </div>

              {otpShow && (
                <div className="pt-2">
                  <label className="block text-xs font-semibold text-gray-700 mb-2">
                    Enter 6-Digit Verification Code
                  </label>
                  <div className="flex items-center justify-between gap-2">
                    {Inputref.current.map((ref, index) => {
                      return (
                        <input
                          key={index}
                          ref={(e) => (Inputref.current[index] = e)}
                          onChange={(e) => HandleChange(index, e.target.value)}
                          onKeyDown={(e) => InputHandler(index, e)}
                          value={otpValue[index] || ""}
                          type="text"
                          className="w-11 h-12 text-center text-lg font-bold text-gray-900 border-2 border-gray-200 rounded-xl focus:border-purple-600 focus:ring-2 focus:ring-purple-100 outline-none transition-all"
                          maxLength="1"
                        />
                      );
                    })}
                  </div>
                  <button
                    type="button"
                    disabled={timeLeft > 0 || isSendingOtp}
                    onClick={ResendOtpHandler}
                    className="mt-3 text-xs font-bold text-purple-600 hover:underline cursor-pointer disabled:opacity-50"
                  >
                    {isSendingOtp ? "Sending..." : timeLeft > 0 ? `Resend OTP in ${timeLeft}s` : "Resend OTP"}
                  </button>
                </div>
              )}

              {passwordShow && (
                <div className="space-y-3 pt-2">
                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      New Password
                    </label>
                    <div className="relative flex items-center border border-gray-300 rounded-2xl bg-gray-50/70 focus-within:bg-white focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all h-11 px-3.5">
                      <input
                        onChange={(e) => setpassword2(e.target.value)}
                        value={Password2 || ""}
                        className="w-full bg-transparent text-sm text-gray-900 font-medium outline-none pr-8"
                        type={showResetPassword ? "text" : "password"}
                        placeholder="At least 6 characters"
                      />
                      <button
                        type="button"
                        onClick={() => setShowResetPassword(!showResetPassword)}
                        className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-purple-600 cursor-pointer"
                      >
                        <img src={showResetPassword ? ShowPassword : HidePassword} alt="" className="w-5 h-5 object-contain" />
                      </button>
                    </div>
                    {Password2 && (
                      <p className={`mt-1 text-xs font-medium ${isResetPasswordValid ? "text-green-600" : "text-red-500"}`}>
                        {isResetPasswordValid ? "✓ Valid password" : "Must be at least 6 characters"}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-gray-700 mb-1">
                      Confirm New Password
                    </label>
                    <div className="relative flex items-center border border-gray-300 rounded-2xl bg-gray-50/70 focus-within:bg-white focus-within:border-purple-600 focus-within:ring-2 focus-within:ring-purple-100 transition-all h-11 px-3.5">
                      <input
                        value={Confirm || ""}
                        onChange={(e) => setconfirm(e.target.value)}
                        className="w-full bg-transparent text-sm text-gray-900 font-medium outline-none pr-8"
                        type={showResetConfirmPassword ? "text" : "password"}
                        placeholder="Re-enter new password"
                      />
                      <button
                        type="button"
                        onClick={() => setShowResetConfirmPassword(!showResetConfirmPassword)}
                        className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-purple-600 cursor-pointer"
                      >
                        <img src={showResetConfirmPassword ? ShowPassword : HidePassword} alt="" className="w-5 h-5 object-contain" />
                      </button>
                    </div>
                    {Confirm && (
                      <p className={`mt-1 text-xs font-medium ${isResetConfirmValid ? "text-green-600" : "text-red-500"}`}>
                        {isResetConfirmValid ? "✓ Password matched" : "Passwords do not match"}
                      </p>
                    )}
                  </div>
                </div>
              )}

              <button
                type="button"
                disabled={isSendingOtp || isVerifyingOtp || isChangingPassword}
                onClick={otpShow ? OtpCheckHandler : passwordShow ? SubmitHandler : PhoneHandler}
                className="w-full mt-4 py-3.5 px-6 rounded-2xl bg-purple-600 hover:bg-purple-700 text-white font-bold text-sm shadow-lg shadow-purple-500/20 transition-all active:scale-[0.98] cursor-pointer disabled:opacity-60"
              >
                {isSendingOtp ? "Sending..." : isVerifyingOtp || isChangingPassword ? "Please wait..." : otpShow ? "Verify OTP" : passwordShow ? "Update Password" : "Continue"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
/* jshint ignore:end */
